import { Button, ButtonProps } from '@mantine/core';
import { ComponentPropsWithoutRef, MouseEventHandler, forwardRef } from 'react';

import classNames from './Button.module.scss';

/**
 * @deprecated Use `Button` from `@zorro/design-system/v2/Button` instead.
 * This component will be removed in the next major version.
 *
 * Migration guide:
 * - Replace imports: `import { Button } from '@zorro/design-system/v2/Button'`
 * - Remove unsupported props: color, bg, radius, w, h, fw, p, m, styles
 * - Use variant mapping: primary-red → negative, subtle → tertiary
 *
 * @see libs/web/design-system/src/lib/v2/Button/MIGRATION_PLAN.md
 */
export type IButtonProps = ButtonProps &
  ComponentPropsWithoutRef<'button'> & {
    onClick?: MouseEventHandler<HTMLButtonElement>;
    isHoverDisabled?: boolean;
  };

/**
 * @deprecated Use `Button` from `@zorro/design-system/v2/Button` instead.
 * This component will be removed in the next major version.
 *
 * @see libs/web/design-system/src/lib/v2/Button/MIGRATION_PLAN.md
 */
export const ZorroButton = forwardRef<HTMLButtonElement, IButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      radius = 'md',
      isHoverDisabled = false,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        type="button"
        ref={ref}
        size={size}
        radius={radius}
        variant={variant}
        classNames={classNames}
        data-disable-hover={isHoverDisabled}
        {...props}
      />
    );
  }
);

ZorroButton.displayName = 'ZorroButton';
